// client/src/apps/ive/routes.jsx
import React from "react";
import { Route } from "react-router-dom";

import IVeLayout             from "./index.js";
import Dashboard             from "./pages/Dashboard.jsx";
import Search                from "./pages/Search.jsx";
import Cohort                from "./pages/Cohort.jsx";
import IViewer               from "./pages/IViewer.jsx";
import User                  from "./pages/User.jsx";
import ContainerPage         from "./pages/Container.jsx";

import WaveformPage          from "./pages/Data/Waveform.jsx";
import ImagePage             from "./pages/Data/Image.jsx";
import PersonDetails         from "./pages/Data/PersonDetails.jsx";
import VisitOccurrenceDetails from "./pages/Data/VisitOccurrenceDetails.jsx";

import DataTable             from "./pages/Data/DataTable.jsx";
import ProtectedRoute        from "../../common/ProtectedRoute.js";

const tableNames = [
  "person",
  "death",
  "observation",
  "observation_period",
  "condition_occurrence",
  "procedure_occurrence",
  "visit_occurrence",
  "visit_detail",
  "drug_exposure",
  "device_exposure",
  "measurement",
  "note",
  "note_nlp",
];
const iveRoutes = [
  <Route
    key="ive-root"
    path="/ive"
    element={
      <ProtectedRoute>
        <IVeLayout />
      </ProtectedRoute>
    }
  >
    {/* dashboard & utilities */}
    <Route index element={<Dashboard />} />
    <Route path="search"      element={<Search />} />
    <Route path="cohort"      element={<Cohort table="cohort" />} />
    <Route path="iviewer"     element={<IViewer />} />
    <Route path="user"        element={<User />} />
    <Route path="containers"  element={<ContainerPage />} />

    {/* generic OMOP tables */}
    {tableNames.map((name) => (
      <Route key={name} path={name} element={<DataTable />} />
    ))}

    {/* other data pages */}
    <Route path="waveform" element={<WaveformPage />} />
    <Route path="image"    element={<ImagePage />}   />

    {/* detail views that stay table-specific */}
    <Route path="person/:pid"               element={<PersonDetails />} />
    <Route path="visit_occurrence/:vid"     element={<VisitOccurrenceDetails />} />
  </Route>,
];

export default iveRoutes;
